import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { openModal } from 'store/modals/actions';

import useReturnOffer from 'hooks/subscriptions/useReturnOffer';

import { Box, Button, Text } from 'components/library';

import * as S from './styled';

import { ModalName } from 'types/modals';
import { PaymentMethods } from 'types/enums';
import { IExpiresSubscription } from '../types';

import SubscriptionCardWrapper from './SubscriptionCardWrapper';
import StatusIcon from './StatusIcon';
import SubscriptionCardHeader from './SubscriptionCardHeader';
import PriceRow from './PriceRow';
import { IncludedInYourPlanRow } from './IncludedInYourPlanRow';
import FeePriceRow from './FeePriceRow';

const ExpiresSubscription = ({
  feeData,
  tabIcon,
  heading,
  subscriptionPeriod,
  price,
  isMainSubscription,
  expirationDate,
  subscriptionType,
  isDiscountOfferAvailable,
  isUpgrade,
  paymentMethod,
  isOneTimeProduct,
}: IExpiresSubscription) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { withFee, hasOfferFetched } = useReturnOffer();

  const showDiscountOfferModal = () => {
    dispatch(openModal(ModalName.RETURN_OFFER));
  };

  const shouldShowReturnOfferBtn =
    isDiscountOfferAvailable &&
    hasOfferFetched &&
    isMainSubscription &&
    !withFee &&
    paymentMethod !== PaymentMethods.flexcard &&
    !isOneTimeProduct;

  return (
    <SubscriptionCardWrapper>
      <SubscriptionCardHeader Icon={tabIcon} heading={heading} />
      <S.TextBox>
        <Text color="text-secondary">
          {t('subscription.cancellation.expiresSubscription.bannerText', { expirationDate })}
        </Text>
      </S.TextBox>
      <S.Status>
        <StatusIcon isCancelled isActive />
        <Text type="caption" color="text-secondary">
          {t('subscription.status.canceled')}
        </Text>
        <Text type="caption" color="text-secondary">
          :
        </Text>
      </S.Status>
      <Box $paddingBottom={isDiscountOfferAvailable ? 20 : 0}>
        {feeData ? (
          <FeePriceRow
            period={t('subscription.feeYear')}
            price={feeData.fee_total_price}
            pricePerState={price}
            periodPerState={subscriptionPeriod}
          />
        ) : (
          <PriceRow period={subscriptionPeriod} subscriptionType={subscriptionType} price={price} />
        )}
      </Box>
      {isUpgrade && <IncludedInYourPlanRow isCardRow />}
      {shouldShowReturnOfferBtn && (
        <Button dataLocator="showReturnOfferBtn" onClick={showDiscountOfferModal}>
          {t('subscription.text.showReturnOffer')}
        </Button>
      )}
    </SubscriptionCardWrapper>
  );
};

export default ExpiresSubscription;
